// extracted by mini-css-extract-plugin
export default {"completed-icon":"qLmk4W","completedIcon":"qLmk4W"};